import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import { PayrollPendingProvider } from "./context/PayrollPendingContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import CashBook from "./pages/CashBook";
import Reports from "./pages/Reports";
import Categories from "./pages/Categories";
import Users from "./pages/Users";
import Suspense from "./pages/Suspense";
import AccountsJournal from "./pages/AccountsJournal";
import PettyCashReport from "./pages/PettyCashReport";
import Persons from "./pages/Persons";
import Settings from "./pages/Settings";
import VoucherPrint from "./pages/VoucherPrint";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <BrandingProvider>
      <AuthProvider>
        <PayrollPendingProvider>
          <BrowserRouter>
            <Toaster richColors position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Protected><Layout /></Protected>}>
                <Route index element={<CashBook />} />
                <Route path="suspense" element={<Suspense />} />
                <Route path="journal" element={<AccountsJournal />} />
                <Route path="reports" element={<Reports />} />
                <Route path="reports/petty-cash" element={<PettyCashReport />} />
                {/* Any signed-in user may print — same gate every posting route uses, not admin-only. */}
                <Route path="vouchers/print" element={<VoucherPrint />} />
                {/* Users, Categories and Persons moved under Settings — the master-data screens
                    themselves are unchanged, only where they're mounted. */}
                <Route path="settings" element={<Protected adminOnly><Settings /></Protected>} />
                <Route path="settings/categories" element={<Protected adminOnly><Categories /></Protected>} />
                <Route path="settings/persons" element={<Protected adminOnly><Persons /></Protected>} />
                <Route path="settings/users" element={<Protected adminOnly><Users /></Protected>} />
                {/* Old paths redirect so bookmarks and any internal link keep working. */}
                <Route path="categories" element={<Navigate to="/settings/categories" replace />} />
                <Route path="persons" element={<Navigate to="/settings/persons" replace />} />
                <Route path="users" element={<Navigate to="/settings/users" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </PayrollPendingProvider>
      </AuthProvider>
    </BrandingProvider>
  );
}
